<app-modal-wrapper>
  <app-modal-header class="text-center mx-auto">Change Password </app-modal-header>
  <app-modal-body>
    <form [formGroup]="form" class="text-center">
      <div class="columns mt-2">
        <div class="column is-12">
          <p>
            Enter and confirm the new password below.
          </p>
        </div>
      </div>
      <formly-form [model]="model" [fields]="fields" [form]="form"></formly-form>
    </form>
  </app-modal-body>
  <app-modal-footer class="text-center mx-auto">
    <button class="btn btn-primary" (click)="submit()">
      Change Password
    </button>
  </app-modal-footer>
</app-modal-wrapper>
